import ButtonElement from '@common/layout/ButtonElement.vue';
import ExternalFilterResetWrapper from '@common/ag-grid/component/ExternalFilterResetWrapper.vue';
import Selection from '@common/selection/Selection.vue';
import { defineComponent } from 'vue';
import { translator } from '~/zf/frontend/common/mixins';
import BootstrapVariant from '~/zf/frontend/vendor/bootstrap/BootstrapVariant';
export default defineComponent({
    name: 'MultiOptionsFilter',
    compatConfig: {
        MODE: 3,
    },
    components: {
        ButtonElement,
        ExternalFilterResetWrapper,
        Selection,
    },
    mixins: [translator],
    props: {
        modelValue: {
            type: Array,
            required: true,
        },
        options: {
            type: Array,
            required: true,
        },
        size: {
            default: BootstrapVariant.SMALL,
            type: String,
        },
        multiple: {
            type: Boolean,
            default: true,
        },
        checkboxes: {
            type: Boolean,
            default: false,
        },
        dropDownLabel: {
            type: String,
            required: true,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            isLoading: false,
            BootstrapVariant,
            notAppliedSelection: [],
        };
    },
    computed: {
        selectedItemsCount() {
            return this.modelValue.length;
        },
        isActive() {
            return this.selectedItemsCount !== 0;
        },
        isNoOptionSelected() {
            return !this.isActive;
        },
        isEveryOptionSelected() {
            return this.selectedItemsCount === this.numberOfAvailableOptions;
        },
        numberOfAvailableOptions() {
            return this.availableOptions.length;
        },
        dropDownText() {
            if (this.isNoOptionSelected || this.isEveryOptionSelected) {
                return this.statusText;
            }
            return `${this.statusText} (${this.selectedItemsCount})`;
        },
        statusText() {
            return this.tr(this.dropDownLabel);
        },
        availableOptions() {
            return this.options
                .map((option) => option.groupOptions)
                .flat();
        },
    },
    watch: {
        modelValue: {
            handler() {
                this.setNotAppliedSelectionToActualSelection();
            },
            immediate: true,
        },
    },
    methods: {
        onApplyFiltersClicked() {
            this.$emit('update:modelValue', this.notAppliedSelection.length !== 0 ? this.notAppliedSelection.map((selection) => selection.value) : undefined);
            this.$refs.filterSelection.close();
        },
        onResetFilter() {
            this.$emit('update:modelValue', undefined);
        },
        setNotAppliedSelectionToActualSelection() {
            this.notAppliedSelection = this.modelValue.map((component) => this.availableOptions.find((option) => option.value === component));
        },
    },
});
